<script setup lang="ts">
import UIBreadcrumbs from '@/shared/ui/Breadcrumbs/index';
import ProductDetailCard from '@/pages/product-detail/ui/productDetailCard.vue';
import { useProductDetail } from '@/pages/product-detail/composables/useProductDetail';
import { useModalsStore } from '@/app/store/modals';
import ImagesSlider from '@/pages/product-detail/ui/productDetailImagesSlider.vue';

const Modal = defineAsyncComponent(() =>
  import('@/shared/ui/Modal/index').then(m => m.default),
);

const isMobile = inject('isMobile');

const { breadcrumbs, product } = await useProductDetail();
const useModalStore = useModalsStore();
const modalImageIndex = ref(0);

const handleOpenModal = (index: number) => {
  modalImageIndex.value = index;
};

useSeoMeta({
  title: product.value?.name,
  ogTitle: product.value?.name,
  description: product.value?.description,
  ogDescription: product.value?.description,
  ogImage: product.value?.images[0],
});
</script>

<template>
  <div class="product-detail">
    <div class="product-detail__breadcrumbs">
      <UIBreadcrumbs :breadcrumbs="breadcrumbs" />
    </div>
    <div class="product-detail__card">
      <ProductDetailCard :product="product" @open-modal="handleOpenModal" />
    </div>
    <Modal
      class="product-detail__modal"
      :modal-active="useModalStore.modalState.product"
      :width="isMobile ? '100%' : 700"
      background="transparent"
      :close-button-color="isMobile ? '#696969' : '#fff'"
      @close="useModalStore.setModalState('product', false)"
    >
      <ImagesSlider
        :images="product.images"
        :product="product"
        is-show-navigation
        :image-height="isMobile ? '400px' : '550px'"
        :start-index="modalImageIndex"
      />
    </Modal>
  </div>
</template>

<style lang="less">
.product-detail {
  .container-d();

  margin-top: @size-x8;
  margin-bottom: 56px;

  &__breadcrumbs {
    margin-bottom: @size-x6;
  }
}
</style>
